/*
|-------------------------------------------------------------------------------
| 公共数据
|-------------------------------------------------------------------------------
*/
import { getLoginApollo } from '@/api/apply'
import { queryAppUrls } from '@/api/appUrls'
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

const apolloStore = defineStore({
  state: () => ({
    switchConf: {
      fintech_fe_baldr_login_page: {
        loginPage: [
          {
            resource: 'mgm',
            topPic: '',
            bottomPic: '',
          },
          {
            resource: 'market',
            topPic: '',
            bottomPic: '',
          },
          {
            resource: 'offical',
            topPic: '',
            bottomPic: '',
          }
        ],
        loginPageDifferent: [
            //ec
            {
                resource: 'ec',
                topPic: '',
                bottomPic: '',
                materialType:"",
            },
           //mgm
          {
            resource: 'mgm',
            topPic: '',
            bottomPic: '',
            materialType:"",
          },
          // 官网
          {
            resource: 'offical',
            topPic: '',
            bottomPic: '',
            materialType:"",
          },
           //脸书
          {
            resource: 'meta', 
            topPic: '',
            bottomPic: '',
            materialType:"",
          },
          //谷歌
          {
            resource: 'google', 
            topPic: '',
            bottomPic: '',
            materialType:"",
          },
          //抖音
          {
            resource: 'tiktok', 
            topPic: '',
            bottomPic: '',
            materialType:"",
          },
        ],
        default: true,
      },
      fintech_fe_baldr_address_rule: {
        addressRule: '',
      },
      // 年龄挡板
      switch_age_barrier: {
        minAge: 19, // 验证年龄age符合标准： minAge <= age <= maxAge
        maxAge: 0, // 0表示不限制年龄上限，配置maxAge时，要保证maxAge>minAge
        data: {
          'es-MX': {
            curpTip:
              'Debes tener 19 años o más para realizar tu solicitud. Verifica si tu CURP es correcta.',
          },
          'en-US': {
            curpTip:
              'You must be 19 or over to apply. Please verify whether your CURP is correct',
          },
        },
      },
      fintech_fe_baldr_external_app_link_urls: {
        appUrls: [],
      },
      // 金额上限
      switch_max_limt_outside: {
        limt:'58,800'
      }
    },
    ABTestResult: {
      // 灰度 征信授权验证码页 是否显示EVA披露
      // 0-不显示 1-显示
      fintech_baldr_grayscale_verification_eva: {
        isShowEva: 0,
      },
       fintech_fe_baldr_download_button: {
        isNewButton: 0,
      },
      // ab 进度条测试 进度条文案分组测试
      fintech_fe_progress_bar_copywriting: {
        type: 'A', //A：组别1、B:组别2、C：组别3、D：组别4
      },
      // 外投渠道下载页移除主端实验
      fintech_baldr_remove_passenger_button: {
        isRemove: 0,
      }
    },
  }),
  mutations: {
    saveSwitchConf(state, data) {
      // 浅拷贝即可
      Object.assign(state.switchConf, data)
    },
    saveABTestResult(state, data) {
      // 浅拷贝即可
      Object.assign(state.ABTestResult, data)
    },
  },
  actions: {
    async getLoginApollo(store, data) {
      const { fintech_fe_baldr_login_page } = store.state.switchConf
      // 获取过apollo则无需再次请求
      if (!fintech_fe_baldr_login_page.default) return
      let res
      try {
        res = await getLoginApollo(data)
      } catch (err) {
        console.log('err: ', err);
        return
      }
      store.commit('saveSwitchConf', {
        fintech_fe_baldr_login_page: res.data?.fintech_fe_baldr_login_page,
        default: false,
      })
    },
  },
  getters: {
    // 获取对应渠道（mgm、官网）的appurl配置
    getCurrentChanelAppUrls: (state) => (channel: string) => {
      const urls = state.switchConf.fintech_fe_baldr_external_app_link_urls?.appUrls
      return urls.find((item: { channel: string }) => item.channel === channel)
    }
  },
})

export default apolloStore
export type IApolloStoreState = IStoreState<
  typeof apolloStore.state
>
